import "./css/App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {BrowserRouter,  Routes, Route} from "react-router-dom";
import Header from "./components/Header";
import { useEffect } from "react";
import OAuthInfo from "@arcgis/core/identity/OAuthInfo";
import esriId from "@arcgis/core/identity/IdentityManager";
import Login from "./components/Login";
import AnalyseTool from "./components/AnalyseTool";
import { useImmerReducer } from "use-immer";
import StateContext from "./contexts/StateContext";
import DispatchContext from "./contexts/DispatchContext";

const initialState = {
    name: "",
    username: "",
    ifSignedIn: false,
    authInfoState: new OAuthInfo({
        // appId: "TKWFrU4tk50YsbTU",
        appId: "PMeM755HdM9kKQyS",
        portalUrl: "https://ispacevm09.researchstudio.at/portal/",
        popup: false,
    }),
};

function ReducerFunction(draft, action) {
    // eslint-disable-next-line default-case
    switch (action.type) {
        case "userLogin":
            draft.name = action.name;
            draft.username = action.username;
            draft.ifSignedIn = true;
            break;
        case "userLogout":
            draft.name = "";
            draft.username = "";
            draft.ifSignedIn = false;
            break;
    }
}

function App() {
    const [state, dispatch] = useImmerReducer(ReducerFunction, initialState);

    useEffect(
            ()=>{
                esriId.registerOAuthInfos([state.authInfoState]);
            }, [/*only after initial render, so it's an empty array*/]
        )

    return (
        <StateContext.Provider  value={state} className="app-container">
            <DispatchContext.Provider value={dispatch}>
                <BrowserRouter basename={process.env.REACT_APP_BASE_URL}>
                    <Header  />
                    <Routes>
                        <Route path="/" element={<Login />}></Route>
                        <Route path="/analyse" element={<AnalyseTool />}></Route>
                    </Routes>
                </BrowserRouter>
            </DispatchContext.Provider>
        </StateContext.Provider>
    );
}

export default App;
